/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDailyGovernanceReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDailyGovernanceReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDailyGovernanceReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDailyGovernanceReport>): BackgroundJobPayloadForDailyGovernanceReport {
        let obj = Object.assign(new BackgroundJobPayloadForDailyGovernanceReport(), model);
        BackgroundJobPayloadForDailyGovernanceReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDailyGovernanceReport>): BackgroundJobPayloadForDailyGovernanceReport {
        if (!model) return null;
        return BackgroundJobPayloadForDailyGovernanceReport.newInstance(<BackgroundJobPayloadForDailyGovernanceReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDailyGovernanceReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForDailyGovernanceReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDailyGovernanceReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDailyGovernanceReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
